import { Component, Input, OnInit } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';

import { Mediaclip, MediaclipAsset } from '../../../interfaces/mediaclip';
import { Playlist } from '../../../interfaces/playlist';
import { Project } from '../../../interfaces/project';
import { Publication } from '../../../interfaces/publication';
import { OverlayService } from '../../../services/overlay.service';
import { ClipboardService } from 'ngx-clipboard';
import { PublicationService } from '../../../services/publication.service';

import { Subscription } from 'rxjs';
import { NgForm } from '@angular/forms';
import { EmbedPreviewConfiguration } from '../../../components/library/embed-preview.component';

export interface BbVastCreativePreviewComponent {
	autoPlay?: boolean;
	standAlone?: boolean;
	alwaysShow?: boolean;
	showEmbargo?: boolean;
	showVideo?: boolean;
}

@Component({
	selector: 'bb-vast-creative-preview',
	templateUrl: './bb-vast-creative-preview.component.html',
	styleUrls: ['./bb-vast-creative-preview.component.scss']
})

export class BbVastCreativeComponent implements OnInit {

	@Input() mediaclip: Mediaclip;
	@Input() project: Project;
	@Input() configuration: EmbedPreviewConfiguration;
	@Input() playlist: Playlist;
	@Input() inModal: boolean;
	@Input() form: NgForm;
	@Input() assetId: string;

	@Input() isActive = true;

	embed = false;
	baseUrl = '';
	selectedAssetRef: any = {};
	settings: any = { showVastAdvanced: false };
	private subscriptions = new Subscription();

	constructor(
		private overlayService: OverlayService,
		private clipboard: ClipboardService,
		private publicationService: PublicationService,
		private translate: TranslateService
	) {
	}

	ngOnInit() {
		// configuration defaults
		if (!this.configuration) {
			this.configuration = {};
		}
		if (typeof this.configuration.autoPlay === 'undefined') {
			this.configuration.autoPlay = false;
		}

		if (typeof this.configuration.showVideo === 'undefined') {
			this.configuration.showVideo = true;
		}
		if (this.mediaclip) {
			this.selectedAssetsInit(this.mediaclip.assets);
		}

		this.subscriptions.add(this.publicationService.getData().subscribe((publication: Publication) => {
			if (publication && publication.baseurl) {
				this.baseUrl = publication.baseurl;
			}
		}));
	}

	ngDestroy() {
		this.subscriptions.unsubscribe();
	}

	copyText(text: string) {
		this.clipboard.copyFromContent(text);
		this.overlayService.createToast(this.translate.instant('URL_COPIED_TO_CLIPBOARD'), 'copy');
	}

	getVastPreviewUrl(url: string) {
		return url
			? 'https://support.bluebillywig.com/vast-inspector#!/vast_type=vast_url/position=preroll/rendering=html5/hide_settings=off/hide_log=off/vast_url='
			+ encodeURIComponent(url)
			: '';
	}

	selectedAssetsInit(assets: MediaclipAsset[]) {
		if (assets && assets.length) {
			assets.forEach((asset) => {
				if (asset && asset.jobdefid && asset.jobdefid !== 'undefined' && asset.mediatype !== 'MP4_TIMELINE') {
					this.selectedAssetRef[asset.jobdefid] = true;
				}
			});
		}
	}

	getVastUrl(type: string) {
		if (this.mediaclip) {
			let baseUrl = this.baseUrl.replace('http://', 'https://');
			if (baseUrl.indexOf('//') === 0) {
				baseUrl = baseUrl.replace('//', 'https://');
			}

			let qs = type === 'vpaid' ? ('playout=vpaid&output=vpaid') : (type === 'simid' ? 'playout=simid&output=simid' : 'output=vast');
			if (type === 'vast') {
				const mediaFiles: any[] = [];
				delete this.selectedAssetRef.undefined;
				for (const mfid in this.selectedAssetRef) {
					if (mfid && this.selectedAssetRef[mfid]) {
						mediaFiles.push(mfid);
					}
				}
				const selectedAssetRefCount = Object.keys(this.selectedAssetRef).length;
				if (mediaFiles && mediaFiles.length && selectedAssetRefCount !== mediaFiles.length) {
					qs += '&mediafiles=';
					mediaFiles.forEach((mfid, i) => {
						if (mfid && mfid !== 'undefined') {
							qs += mfid + (i < mediaFiles.length - 1 ? ',' : '');
						}
					});
				}
			}
			return (baseUrl + '/mediaclip/' + this.mediaclip.id + '.xml?' + qs);
		} else {
			return '';
		}
	}
}
